<template>
  <slot />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useLocaleCookie } from '@/composables/useLocale';
import { useStoreRootI18n } from '@/composables/useTranslation';

/**
 * Wrapper that owns app-level i18n bootstrap (including auth UI outside routed layouts).
 */
export default defineComponent({
  name: 'TranslationProvider',
  setup() {
    useLocaleCookie();
    useStoreRootI18n();
  },
});
</script>
